import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { DragDropContext } from "react-beautiful-dnd";
import HomeController from "./HomeController";
import HomeSidebar from "./HomeSidebar";
import HomeSecondaryNav from "./HomeSecondaryNav";
import HomeContent from "./HomeContent";
const HomeControllerPresentation = (props) => (
// @ts-expect-error - TS2786 - 'HomeController' cannot be used as a JSX component.
_jsx(HomeController, Object.assign({}, props, { children: (provided) => (_jsx(_Fragment, { children: _jsx(DragDropContext, { onDragEnd: (result) => {
                // setTempCourseSectionIds([]);
                // setTempBreakIds([]);
                if (result.destination &&
                    result.destination.droppableId === "scheduler") {
                    if (result.source.droppableId === "SchedulerCourseSection") {
                        provided.setSelectedCourseSections([
                            ...provided.selectedCourseSections.map((sec) => sec.id),
                            result.draggableId,
                        ]);
                    }
                    else if (result.source.droppableId === "SchedulerBreak") {
                        provided.setSelectedBreaks([
                            ...provided.selectedBreaks.map((sec) => sec.id),
                            result.draggableId,
                        ]);
                    }
                }
            }, onDragStart: ({ source, draggableId }) => {
                if (source.droppableId === "SchedulerCourseSection") {
                    // setTempCourseSectionIds(s => [...s, draggableId]);
                }
                else if (source.droppableId === "SchedulerBreak") {
                    // setTempBreakIds(ids => [...ids, draggableId]);
                }
            }, children: _jsx(HomeSidebar, Object.assign({}, provided, { children: _jsx(HomeSecondaryNav, Object.assign({}, provided, { children: _jsx(HomeContent, Object.assign({}, provided)) })) })) }) })) })));
export default HomeControllerPresentation;
